require('./myProfileFiscalView.scss');

// @ vendor
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');

// @ actions
const fiocDocumentation = require('actions/fiocDocumentation');
const profile = require('actions/profile');
const profileEditorActions = require('actions/profileEditor');

// @ commons
const { CommercialAds } = require('components/commons/commercialAds/commercialAds');
const { formatText, FormattedText, getFinalTitle } = require('core/i18n').i18n;
const { OKButton } = require('commonsComponents/OKButton');
const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
const { OKLink } = require('commonsComponents/OKLink');
const { OKMessage } = require('commonsComponents/OKMessage');
const { OKSectionBox } = require('commonsComponents/OKSectionBox');

// @ components
const { CallMeBack } = require('components/callMeBack/callMeBack');
const ContactInfoBox = require('components/myProfile/contactInfoBox/contactInfoBox');
const ErrorStep = require('components/myProfile/myProfileEditor/ErrorStep');
const MyProfileEditorWizard = require('components/myProfile/myProfileEditor/MyProfileEditorWizard');
const TaxAdditionalCountryData = require('components/myProfile/taxAdditionalCountryList/taxAdditionalCountryData');
const SuccessStep = require('components/myProfile/myProfileEditor/SuccessStep');

// @ helpers
const PersonalDataHelper = require('utilities/personalDataHelper');
const { FISCAL_DATA_FATCA } = require('utilities/tagging');

// @ constants
const { getTranslatedCountry } = require('constants/countries');
const PROVINCES = require('constants/provinces');
const {
    PROFILE_EDIT_FORMS: {
        FISCAL_DATA
    }
} = require('constants/myProfileEditor');

class MyProfileFiscalView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            disableNextButton: false
        }
        this.handleCancel = this.handleCancel.bind(this);
        this.handleFinish = this.handleFinish.bind(this);
        this.isReady = this.isReady.bind(this);
        this.beforeLeaving = this.beforeLeaving.bind(this);
        this.handleConfirmLeave = this.handleConfirmLeave.bind(this);
    }

    componentDidMount() {
        const {
            immFiocDocumentation,
            getFiocStatus,
            requestProfile,
            history,
            reset
        } = this.props;

        reset();
        requestProfile(history);
        if (!immFiocDocumentation.get('fetched') && !immFiocDocumentation.get('isStatusFetching')) {
            getFiocStatus();
        }
    }

    componentWillReceiveProps(nextProps) {
        const { immProfileEditor, routingState } = this.props;
        const currentPath = routingState.locationBeforeTransitions.pathname;
        const newPath = nextProps.routingState.locationBeforeTransitions.pathname;
        if (currentPath == newPath && immProfileEditor.get('submitSuccessful')) {
            this.props.reset();
        }
    }

    componentWillUnmount() {
        const { reset } = this.props;
        reset();
    }

    handleCancel() {
        this.props.history.push('/myprofile/fiscal');
    }

    handleConfirmLeave() {
        const { reset, requestProfile, history } = this.props;
        reset();
        requestProfile(history);
    }

    handleEditButtonClick(formToLoad) {
        const { setEditMode } = this.props;
        setEditMode(formToLoad);
    }

    handleFinish() {
        const { postFiscalDataChange, requestProfile } = this.props;
        postFiscalDataChange(requestProfile);
    }

    beforeLeaving() {
        const { immProfileEditor, reset } = this.props;
        if (immProfileEditor.get('submitSuccessful') && immProfileEditor.get('willLeave')) {
            reset();
        }
    }

    isReady() {
        return false;
    }

    handleNextDisableButton = value => {
        this.setState({ disableNextButton: value })
    }

    buildEditButton(formToLoad) {
        const { immProfileFields } = this.props;
        const canEdit = immProfileFields.get('isFetching');

        return (
            <span className="my-profile-fiscal-view__edit-button">
                <OKButton
                    isOKButtonOld={true} //this button should be changed to an action
                    modifier="tasks-light-small"
                    onClick={() => this.handleEditButtonClick(formToLoad)}
                    disabled={canEdit}
                    loaderColor="dark"
                    loaderSize="small"
                >
                    <i className="icon-editar" />
                </OKButton>
            </span>
        );
    }

    buildDataFromGroup(title, dataGroup, titleButton, tooltipOffset, toolTipContent) {
        return (
            <OKInformativeList
                columns={2}
                title={title}
                titleButton={titleButton}
                tooltipOffset={tooltipOffset}
                icon={!!toolTipContent}
                information={toolTipContent}
            >
                {
                    dataGroup.map((data, index) => {
                        const element = (
                            <OKInformativeListItem
                                key={index}
                                title={formatText(data.title)}
                                onlyChildren
                                editButton={data.editButton}
                                icon={!!data.toolTipContent}
                                tooltipOffset={data.tooltipOffset}
                                information={formatText(data.toolTipContent)}
                            >
                                {data.value}
                            </OKInformativeListItem>
                        );

                        return data.visible ? element : null;
                    })
                }
            </OKInformativeList>
        );
    }

    buildListCountriesWithAdditionalTaxing() {
        const { immProfileFields } = this.props;
        const listCountriesAdditionalTaxing = PersonalDataHelper.getListCountriesWithAdditionalTaxing(immProfileFields);
        let content;

        if (listCountriesAdditionalTaxing && (listCountriesAdditionalTaxing.size === 0)) {
            content = <FormattedText className="ok-informative-list-item__body-text" value="profile-taxInformation_noAdditionalTributation" />;
        } else {
            content = listCountriesAdditionalTaxing.map((item, index) => (
                <div className="ok-informative-list-item__body-text" key={index}>
                    <TaxAdditionalCountryData immCountry={item} />
                </div>
            ));
        }

        return content;
    }

    buildFiscalEdition() {
        const {
            actionChangeValue,
            deleteAdditionalCountries,
            immProfileEditor,
            immProfileFields,
            setAddingTaxAdditionalCountry,
            setEditingTaxAdditionalCountry,
            setVisibleStep,
            setField,
            setWillCancel,
            updateAdditionalCountries,
            validateStep
        } = this.props;

        return (
            <MyProfileEditorWizard
                disableNextButton={this.state.disableNextButton}
                onHandleNextDisableButton={this.handleNextDisableButton}
                actionChangeValue={actionChangeValue}
                beforeLeaving={this.beforeLeaving}
                immProfileFields={immProfileFields}
                immProfileEditor={immProfileEditor}
                isReady={this.isReady}
                onCancel={this.handleCancel}
                onConfirmLeave={this.handleConfirmLeave}
                onFinish={this.handleFinish}
                setAddingTaxAdditionalCountry={setAddingTaxAdditionalCountry}
                setEditingTaxAdditionalCountry={setEditingTaxAdditionalCountry}
                setVisibleStep={setVisibleStep}
                setField={setField}
                setWillCancel={setWillCancel}
                deleteAdditionalCountries={deleteAdditionalCountries}
                updateAdditionalCountries={updateAdditionalCountries}
                processType={FISCAL_DATA_FATCA}
                validateStep={validateStep}
            />
        );
    }

    buildFiscalView() {
        const { immFiocDocumentation, immProfileFields } = this.props;
        const taxData = PersonalDataHelper.getTaxData(immProfileFields);
        const birthCountry = getTranslatedCountry(taxData.birthCountry);
        const birthProvince = PROVINCES[taxData.birthProvince];
        const birthSquare = taxData.birthSquare;
        const fatcaValue = immFiocDocumentation.get('codMessage') == '10' &&
            !immFiocDocumentation.get('fiocRequested') &&
            immFiocDocumentation.get('documentationRequested') &&
            immFiocDocumentation.get('fiocStatus') === 0 &&
            immFiocDocumentation.get('documentList').toJS().filter(d => d.codTipoDocumento == "30").length ?
                <OKLink modifier="emphasize" to="/myprofile/fatca">{formatText("fatcaSection-link")}</OKLink> :
            formatText("fatcaSection-updated");
        const groupData03 = [
            {
                title: 'profile-birthCountry',
                visible: true,
                value: birthCountry
            },
            {
                title: 'profile-taxInformation_birthLocality',
                visible: true,
                value: birthSquare
            },
            {
                title: 'profile-taxInformation_birthProvince',
                visible: Boolean(birthProvince),
                value: birthProvince
            },
            {
                title: 'profile-taxInformation_CountriesAdditionalTributationTitle',
                visible: true,
                value: this.buildListCountriesWithAdditionalTaxing()
            }
        ];
        const groupData05 = [
            {
                title: 'fatcaSection-activity',
                visible: true,
                value: fatcaValue
            }
        ];
        const groupData03Built = this.buildDataFromGroup('profile-taxInformation_title', groupData03, this.buildEditButton(FISCAL_DATA));
        const groupData05Built = this.buildDataFromGroup('fatcaSection-title', groupData05, null, [0, -15], 'fatcaSection-titleTooltip');


        return (
            <div className="row">
                <div className="col-md-12">
                    <OKSectionBox className="my-profile-fiscal-view" title={formatText('profile-profile_fiscalTitle')}>
                        <section className="my-profile-fiscal-view__fiscal-data">
                            {groupData05Built}
                            {groupData03Built}
                        </section>
                    </OKSectionBox>
                </div>
            </div>
        );
    }

    buildEditor() {
        const { immProfileEditor } = this.props;
        const boxTitle = formatText('profile-boxTitle');
        const boxBody = (
            <OKMessage type="important">
                <FormattedText value="profile-boxBody" />
            </OKMessage>
        );

        let fiscalSection;

        if (immProfileEditor.get('editMode')) {
            fiscalSection = this.buildFiscalEdition();
        } else {
            fiscalSection = this.buildFiscalView();
        }

        return (
            <div className="row grid-view--content-position-negative">
                <div className="col-xs-12 col-md-8">
                    {fiscalSection}
                </div>
                <div className="col-xs-12 col-md-4">
                    <div className="row">
                        <div className="col-xs-6 col-md-12 grid-view--variable-cell-separation">
                            <ContactInfoBox
                                boxTitle={boxTitle}
                                boxBody={boxBody}
                                hasMessage={true}
                            />
                        </div>
                        <div className="col-xs-6 col-md-12 grid-view--fix-cell-separation">
                            <CallMeBack pageTitle={formatText('breadcrumb-personalInformation')} hasEntrance={false} />
                        </div>
                        <div className="col-xs-12 grid-view--fix-cell-separation">
                            <CommercialAds path="edit" type="banner-a" />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    buildBody() {
        const { immProfileEditor, immProfileFields } = this.props;
        const isFetching = immProfileEditor.get('isFetching');
        const submitSuccessful = immProfileEditor.get('submitSuccessful');
        const hasError = immProfileEditor.get('errorReceived') !== '';

        let bodyContent;

        if (!isFetching && submitSuccessful) {
            bodyContent = (
                <div className="grid-view--content-position-negative">
                    <SuccessStep
                        mainProfileView={false}
                        immProfileEditor={immProfileEditor}
                        immProfileFields={immProfileFields}
                        onConfirmLeave={this.handleConfirmLeave}
                        processType={FISCAL_DATA_FATCA}
                    />
                </div>
            );
        } else if (hasError) {
            bodyContent = (
                <div className="grid-view--content-position-negative">
                    <ErrorStep
                        mainProfileView={false}
                        onConfirmLeave={this.handleConfirmLeave}
                        processType={FISCAL_DATA_FATCA}
                    />
                </div>
            );
        } else {
            bodyContent = this.buildEditor();
        }

        return bodyContent;
    }

    render() {
        const { immProfileEditor } = this.props;
        const breadcrumbText = immProfileEditor.get('editMode') ?
            formatText('breadcrumb-breadcrumb_modifyFiscalData') :
            formatText('breadcrumb-breadcrumb_viewFiscalData');
        const mappingBreadcrumb = [
            {
                text: formatText('breadcrumb-personalInformation'),
                url: '/myprofile/edit'
            },
            {
                text: breadcrumbText,
                url: ''
            }
        ];
        const fiscalTitle = immProfileEditor.get('editMode') ?
            getFinalTitle('profile-profile_fiscalViewTitleHeader') :
            getFinalTitle('profile-profile_fiscalTitle');
        const editorBody = this.buildBody();

        return (
            <div>
                <div className="container-fluid">
                    <div className="row">
                        <OKCover size="medium" section="pg" customClass="col-xs-12">
                            <OKHeaderSubPage
                                breadcrumbConfig={mappingBreadcrumb}
                                finalTitle={fiscalTitle}
                            />
                        </OKCover>
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid">
                        {editorBody}
                    </div>
                </div>
            </div>
        );
    }
}

MyProfileFiscalView.propTypes = {
    actionChangeValue: PropTypes.func.isRequired,
    deleteAdditionalCountries: PropTypes.func.isRequired,
    getFiocStatus: PropTypes.func.isRequired.isRequired,
    immFiocDocumentation: PropTypes.object.isRequired,
    immProfileEditor: PropTypes.object.isRequired,
    immProfileFields: PropTypes.object.isRequired,
    postFiscalDataChange: PropTypes.func.isRequired,
    requestProfile: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    routingState: PropTypes.object.isRequired,
    setAddingTaxAdditionalCountry: PropTypes.func.isRequired,
    setEditingTaxAdditionalCountry: PropTypes.func.isRequired,
    setEditMode: PropTypes.func.isRequired,
    setField: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    updateAdditionalCountries: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
};

module.exports.constructor = MyProfileFiscalView;

module.exports.MyProfileFiscalView = withRouter(connect(
    state => ({
        immFiocDocumentation: state.fiocDocumentation,
        immProfileEditor: state.profileEditor,
        immProfileFields: state.profile,
        routingState: state.routing
    }),
    {
        actionChangeValue: profileEditorActions.actionChangeValue,
        deleteAdditionalCountries: profileEditorActions.deleteAdditionalCountries,
        getFiocStatus: fiocDocumentation.getFiocStatus,
        postFiscalDataChange: profileEditorActions.postFiscalDataChange,
        requestProfile: profile.requestProfile,
        reset: profileEditorActions.reset,
        setAddingTaxAdditionalCountry: profileEditorActions.setAddingTaxAdditionalCountry,
        setEditingTaxAdditionalCountry: profileEditorActions.setEditingTaxAdditionalCountry,
        setEditMode: profileEditorActions.setEditMode,
        setField: profileEditorActions.setField,
        setVisibleStep: profileEditorActions.setVisibleStep,
        setWillCancel: profileEditorActions.setWillCancel,
        updateAdditionalCountries: profileEditorActions.updateAdditionalCountries,
        validateStep: profileEditorActions.validateStep,
    }
)(MyProfileFiscalView));
